export var ITEM_COURSE;

(function (ITEM_COURSE) {
  ITEM_COURSE["DEFAULT_COURSE"] = "DEFAULT_COURSE";
  ITEM_COURSE["ALTERNATE_COURSE"] = "SECOND_COURSE";
})(ITEM_COURSE || (ITEM_COURSE = {}));